import { render } from "./CoverageScreen.vue?vue&type=template&id=f07c0324"
import script from "./CoverageScreen.vue?vue&type=script&lang=js"
export * from "./CoverageScreen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Jett\\Desktop\\bg-insieme\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__